import { formatDate } from "../../../../../extentions/date";
import styles from "./TrackPackage.module.scss";
import order_track_arrow from "../../../../../assets/images/packages/Arrow.svg";
import { useEffect, useState } from "react";
import { PackageHistory } from "../../../../../interface/site.interface";
import { PackagesService } from "../../../../../services/packages.service";
import Spinner from "../../../../shared/spinner/Spinner";
import closeIon from "../../../../../assets/images/referal/Close Icon.svg";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../redux/store";
interface TrackPackageProps {
  packId: number | null;
  setopenFollowModal: (value: boolean) => void;
}

const TrackPackage = ({ packId, setopenFollowModal }: TrackPackageProps) => {
  const [track, setTrack] = useState<PackageHistory[]>([]);
  const [loading, setLoading] = useState(false);
  const { data } = useSelector((state: RootState) => state.translationData);

  useEffect(() => {
    setLoading(true);
    if (packId !== null) {
      PackagesService.getPackagesHistory(packId)
        .then((res) => setTrack(res.data.original.events))
        .catch((err) => console.error(err))
        .finally(() => setLoading(false));
    }
  }, [packId]);

  return (
    <div className={styles.overlay}>
      <div className={styles.container}>
        <div
          className={styles.close_icon}
          onClick={() => setopenFollowModal(false)}
        >
          <img src={closeIon} alt="" />
        </div>
        <div>
          <h2 className={styles.title}>{data?.tracking_search}</h2>
          {loading ? (
            <div style={{ marginTop: "40px" }}>
              <Spinner />
            </div>
          ) : (
            <div className={styles.steps_container}>
              {track?.map((step, index) => (
                <div key={index} className={styles.step_item_line}>
                  <div className={styles.step_item}>
                    <div className={styles.step_label}>{step.status}</div>

                    <div
                      style={{
                        backgroundColor:
                          step.status === "Kuryerlə təhvil verildi"
                            ? "#36654A"
                            : "",
                      }}
                      className={styles.status_box}
                    >
                      <img src={order_track_arrow} alt="" />
                    </div>

                    <div className={styles.step_label_date_cont}>
                      <div className={styles.step_label}>{step.status}</div>
                      <div className={styles.step_date}>
                        {formatDate(step.date)}
                      </div>
                    </div>
                  </div>

                  {index !== track.length - 1 && (
                    <div className={styles.step_line}></div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TrackPackage;
